import React,{useState} from "react";
import { Grid, Box } from "@mui/material";
// import ProgressTracker from "./ProgressTracker";
import ComplaintSatus from "./ComplaintStatus";
import Print from "./Print";
import Complaint_stats from "./Complaint_stats";
import AdminTable from "./AdminTable";

const Dashboard1 = () => {
  // const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  // const userId = searchParams.get('userId');

  const designation=localStorage.getItem('designation');

  const [selectedComplaintId, setSelectedComplaintId] = useState(1);

  const handleRowClick = (complaintId) => {
    setSelectedComplaintId(complaintId);
  };


  if(designation === "Complainer")
  {
    return (
      <Box>
        <Grid container spacing={0}>
          <Grid item xs={12} lg={12}>
            <ComplaintSatus onRowClick={handleRowClick}/>
          </Grid>
          {/* <Grid item xs={12} lg={3}>
            <ProgressTracker complaintId={selectedComplaintId} />
          </Grid>  */}
        </Grid>
      </Box>
    );
  }

  // else if(designation === "AO")
  // {
  //   return (
  //     <Box>
  //       <Grid container spacing={0}>
  //         {/* ------------------------- row 1 ------------------------- */}
  //         <Grid item xs={12} lg={12}>
  //           {/* <ComplaintsStatistics /> */}
  //         </Grid>
          // <Grid item xs={12} lg={4}>
          //   <ProgressTracker complaintId={selectedComplaintId} />
          // </Grid> 
  //       </Grid>
  //     </Box>
  //   );
  // }

  else if(designation === "Head of department" || designation === "Director" || designation === "AO Officer")
  {
    return (
      <Box>
        <Grid container spacing={0}>
          <Grid item xs={12} lg={12}>
            <ComplaintSatus onRowClick={handleRowClick}/>
          </Grid>
          {/* <Grid item xs={12} lg={3}>
            <ProgressTracker complaintId={selectedComplaintId} />
          </Grid>  */}
        </Grid>
      </Box>
    );
  }

  else if(designation === "Supervisor")
  {
    return (
      <Box>
        <Grid container spacing={0}>
          <Grid item xs={12} lg={12}>
            <ComplaintSatus onRowClick={handleRowClick}/>
          </Grid>
          {/* <Grid item xs={12} lg={3}>
            <ProgressTracker complaintId={selectedComplaintId} />
          </Grid>  */}
        </Grid>
      </Box>
    );
  }

  else if(designation === "Technician")
  {
    return (
      <Box>
        <Grid container spacing={0}>
        <Grid item xs={12} lg={12}>
            <ComplaintSatus onRowClick={handleRowClick}/>
        </Grid>
        <Grid item xs={12} lg={12}>
            <Print complaintId={selectedComplaintId} />
        </Grid>
        </Grid>
      </Box>
    );
  }
  else if(designation === "Admin")
    {
      return (
        <div>
          <AdminTable/>
        </div>
      )
    }
};

export default Dashboard1;
